import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=5127c6e3&scoped=true&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5127c6e3",
  null
  
)

export default component.exports